<!-- XWAI is staff-only; render nothing unless the user has xwaiAccess. -->
@if (hasAccess()) {
<!-- Floating toggle button -->
<button
  class="ai-panel-fab"
  [class.ai-panel-fab--hidden]="open()"
  (click)="toggle()"
  nz-tooltip
  nzTooltipTitle="Ask XWAI about this job"
>
  <img src="/assets/icons/xwai-icon-cropped.png" alt="XWAI" />
  <span class="ai-panel-fab-label">Ask XWAI</span>
  @if (hasUnread()) {
    <span class="ai-panel-fab-dot" aria-label="New response ready"></span>
  }
</button>

<!-- Slide-in panel -->
<div
  class="ai-panel"
  [class.ai-panel--open]="open()"
  [class.ai-panel--expanded]="expanded()"
>
  <div class="ai-panel-header">
    <span class="ai-panel-title">
      <img src="/assets/icons/xwai-icon-cropped.png" alt="XWAI" />
      XWAI
    </span>
    <span class="ai-panel-tabs">
      <button
        class="ai-panel-tab"
        [class.ai-panel-tab--active]="activeTab() === 'copilot'"
        (click)="selectTab('copilot')"
      >
        Copilot
      </button>
      <button
        class="ai-panel-tab"
        [class.ai-panel-tab--active]="activeTab() === 'xwai-v2'"
        (click)="selectTab('xwai-v2')"
      >
        XWAI v2
      </button>
    </span>
    <span class="ai-panel-actions">
      <button
        class="ai-panel-expand"
        (click)="toggleExpanded()"
        nz-tooltip
        [nzTooltipTitle]="expanded() ? 'Shrink' : 'Expand'"
      >
        <span nz-icon [nzType]="expanded() ? 'fullscreen-exit' : 'fullscreen'" nzTheme="outline"></span>
      </button>
      <button class="ai-panel-close" (click)="toggle()" nz-tooltip nzTooltipTitle="Close">
        <span nz-icon nzType="close" nzTheme="outline"></span>
      </button>
    </span>
  </div>
  <!-- Kept mounted after first open (hidden rather than destroyed when its tab
       isn't active, or the panel is closed) so streams/history/thread_id
       survive close/reopen and tab switches. -->
  @if (hasBeenOpened()) {
    <!-- xwai-root supplies the --xwai-* design tokens the embedded copilot bot
         needs; without it its buttons render white-on-white. -->
    <div class="ai-panel-body xwai-root" [hidden]="activeTab() !== 'copilot'">
      <app-copilot-bot></app-copilot-bot>
    </div>
    <div class="ai-panel-body ai-panel-body--xwai-v2" [hidden]="activeTab() !== 'xwai-v2'">
      <app-xwai-v2-shell [expanded]="expanded()" [embedded]="true"></app-xwai-v2-shell>
    </div>
  }
</div>

<!-- Backdrop -->
@if (open()) {
  <div class="ai-panel-backdrop" (click)="toggle()"></div>
}
}
